<template>  
  <button class="btn btn-primary my-2 my-sm-0" type="submit" @click.prevent="action" :disabled="device.isConnecting">
    <fa-icon v-if="device.isConnecting" :icon="spinner" class="fa-spin" />
    <fa-icon v-else :icon="icon" />
    {{ label }}
  </button>
</template>

<script>
export default {
  name: 'connect',
  props: ['device'],
  data () {
    return {
      defaultLabel: 'Connect',
      progressLabel: 'Connecting',
      icon: 'link',
      spinner: 'spinner',
      inProgress: false
    }
  },
  computed: {
    label () {
      return this.device.isConnecting ? this.progressLabel : this.defaultLabel
    }
  },
  methods: {
    action (e) {
      e.target.blur()

      this.device.connect()
    }
  }
}
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/controls/Connect.vue